import { isNegligibleSentryCapture } from '@flex-packages/error';
import { withScope, captureException } from '@sentry/browser';
import { Component } from 'react';

const DEFAULT_STATE = {
  error: null,
  eventId: null
};
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.resetError = () => {
      this.setState(DEFAULT_STATE);
      this.props.onReset?.();
    };
    this.state = DEFAULT_STATE;
  }
  static getDerivedStateFromError(error) {
    return { error, eventId: null };
  }
  componentDidCatch(error, info) {
    if (this.props.throwOnError?.(error)) {
      throw error;
    }
    withScope((scope) => {
      if (this.props.logLevel) {
        scope.setLevel(this.props.logLevel);
      }
      scope.setExtra("componentStack", info.componentStack);
      const eventId = shouldCaptureSentry(this.props.ignoreSentry, error) ? captureException(error) : null;
      this.setState((prevState) => ({ ...prevState, eventId }));
      this.props.onError?.({
        error,
        info,
        eventId
      });
    });
  }
  render() {
    if (this.state.error) {
      return this.props.renderFallback({
        error: this.state.error,
        eventId: this.state.eventId,
        resetError: this.resetError
      });
    }
    return this.props.children;
  }
}
const shouldIgnoreSentry = (ignoreSentry, error) => {
  switch (typeof ignoreSentry) {
    case "boolean":
      return ignoreSentry;
    case "function":
      return ignoreSentry(error);
    default:
      return false;
  }
};
const shouldCaptureSentry = (ignoreSentry, error) => {
  return !shouldIgnoreSentry(ignoreSentry, error) && !isNegligibleSentryCapture(error);
};

export { ErrorBoundary as default };
//# sourceMappingURL=index.mjs.map
